import React, {useEffect, useRef} from 'react'
import {Button, Col, Form, Input, Row} from "antd";
import {useNavigate} from "react-router-dom";
import HelpVideoLoader from "../../Components/HelpVideoLoader";
import {useTranslations} from "../../lang";
import {clearFunnelEventId, CONSENT_CHANGED_EVENT, getOrCreateFunnelEventId, trackFunnelEvent} from "../../analytics";

export default function Welcome() {

    const eventSent = useRef(false)
    const signupEventId = useRef(getOrCreateFunnelEventId('sign_up'))
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const {translate} = useTranslations()

    useEffect(() => {
        const sendPendingSignup = () => {
            if (eventSent.current) return
            try {
                eventSent.current = trackFunnelEvent('sign_up', {
                    event_id: signupEventId.current,
                    method: 'email',
                })
                if (eventSent.current) clearFunnelEventId('sign_up')
            } catch {
                // Analytics must never interrupt onboarding.
            }
        }
        sendPendingSignup()
        window.addEventListener(CONSENT_CHANGED_EVENT, sendPendingSignup)
        return () => window.removeEventListener(CONSENT_CHANGED_EVENT, sendPendingSignup)
    }, []);

    return (
        <Row justify={"center"}>
            <Col className={"text-center"} md={18} xs={24}>
                <h1>{translate('Welkom!')}</h1>
                <p>{translate('Welkom bij de club van oogsters!')}</p>

                <h2>{translate('Wat wil je gaan oogsten?')}</h2>
                <Row justify={"center"}>
                    <Col xs={24} md={12}>
                        <Form form={form} layout={"horizontal"} onFinish={(values) => {
                            navigate('/crops?search=' + values.query + "&onboarding=1")
                        }}>
                            <Form.Item label={""} name={"query"}>
                                <Input size={"large"} placeholder={translate('Tomaat')}/>
                            </Form.Item>
                            <Form.Item>
                                <Button htmlType={"submit"} type={"primary"} size={"large"}>{translate('Volgende')}</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>

                <h1>{translate('Kijk eerst deze video')}</h1>
                <HelpVideoLoader/>
            </Col>
        </Row>
    )
}